module.exports = __webpack_public_path__ + "img/watermark.b9f492fd.svg";